@if (isNavigating() || isLoading()) {
	<mat-progress-bar style="position: absolute; top: 0; left: 0" mode="indeterminate"></mat-progress-bar>
}
<router-outlet />
